<template>
  <div class="goodItem" @click="tapEvent">
    <van-image class="goodSrc" :src="goodsInfo.PictUrl" />
    <div class="infoBox">
      <div class="topPart">
        <div class="subTop twoRow">
          <span class="title">{{ goodsInfo.Title }}</span>
        </div>
        <div class="subBottom">
          <div class="tag status1">
            <div class="label">补贴</div>
            <div class="content">{{ goodsInfo.TljAmount }}元</div>
          </div>
          <div class="tag status2" v-if="goodsInfo.CouponTotalAmount">领券{{ goodsInfo.CouponTotalAmount }}元</div>
        </div>
      </div>
      <div class="bottomPart">
        <div class="leftPart">
          <div class="content">
            <div class="priceBox">
              <div class="symbol">￥</div>
              <div class="price">{{ goodsInfo.CouponFinalPrice }}</div>
            </div>
            <div class="tip">
              补贴券后价
            </div>
          </div>
          <div class="modify iconfont icon-shandian-shi"></div>
        </div>
        <div class="rightPart">立即购买</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'goodItem',
  props: {
    goodsInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },

  mounted() {},

  methods: {
    ...mapMutations(['SET_GOODS_DETAIL_DATA']),
    tapEvent() {
      this.SET_GOODS_DETAIL_DATA(this.goodsInfo)
      this.$emit('entotTLJDetailPage', this.goodsInfo.NumIID)
    }
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.goodItem {
  display: flex;
  height: vw(150);
  margin-top: vw(18);
  width: 100%;
  box-sizing: border-box;
  padding: 0 2%;
  .goodSrc {
    width: vw(150);
    height: vw(150);
    flex-shrink: 1;
    margin-right: vw(9);
    overflow: hidden;
    border-radius: vw(5);
  }
  .infoBox {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    .topPart {
      width: 100%;
      flex: 1;
      font-size: vw(14);
      .subBottom {
        display: flex;
        flex-wrap: wrap;
        margin-top: vw(5);
        .tag {
          display: flex;
          align-items: center;
          color: #ffab85;
          height: vw(17);
          border-radius: vw(3);
          margin-right: vw(5);
          box-sizing: border-box;
          font-size: vw(11);
          overflow: hidden;
          .label {
            display: flex;
            align-items: center;
            justify-content: space-around;
            background-color: #ec0536;
            height: 100%;
            padding: 0 vw(4);
            color: #fff;
          }
          .content {
            display: flex;
            align-items: center;
            justify-content: space-around;
            height: 100%;
            background-color: #fbf3c9;
            padding: 0 vw(4);
            color: #ec0536;
          }
          &.status2 {
            color: #f23030;
            background-color: #fdebe7;
            padding: 0 vw(4);
          }
        }
      }
    }
    .bottomPart {
      display: flex;
      align-items: center;
      width: 100%;
      height: vw(50);
      border-radius: vw(5);
      overflow: hidden;
      .leftPart {
        display: flex;
        align-items: center;
        justify-content: space-around;
        position: relative;
        width: vw(110);
        height: 100%;
        background: linear-gradient(140deg, #f78036 1%, #f23e48 26%, #fc2c38 100%);
        .content {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #fff;
          .priceBox {
            display: flex;
            align-items: flex-end;
            font-size: vw(11);
            .price {
              font-size: vw(18);
            }
          }
          .tip {
            font-size: vw(12);
          }
        }
        .modify {
          position: absolute;
          right: vw(-28);
          font-size: vw(50);
          line-height: vw(50);
          background: linear-gradient(195deg, #f5d84c 14%, #ff590d 95%);
          -webkit-background-clip: text;
          color: transparent;
          transform: scale(0.8, 1);
        }
      }
      .rightPart {
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex: 1;
        height: 100%;
        background: linear-gradient(146deg, #fdf0b3 4%, #fce993 46%, #fbe26c 83%);
        color: #ed3641;
        font-size: vw(13);
        font-weight: 700;
      }
    }
  }
}
</style>
